import {connect} from "react-redux";
import ExternalMomList from "./List";
import {bindActionCreators} from "redux";
import {momListRequest} from "../../../../service/Valet/action";

const mapStateToProps = (state) => ({
    monListResponse:state.Valet.monListResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            momListRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ExternalMomList);
